import React,{useState} from 'react'
import styled from 'styled-components'
import LabelText from './LabelText'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Modal, { ModalProvider, BaseModalBackground } from "styled-react-modal";
import LargeModal from './LargeModal';

const Button = styled.div`
    display: inline-flex;
    padding: 8px 8px 8px 12px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor:pointer;
    color : ${({ theme }) => theme.playerColor};

    border-radius: 2px;
    border:  1px solid ${({ theme }) => theme.emptyDataBorder};
    background: ${({ theme }) => theme.playerDataBorder};
    
`
interface EmptyDataButtonProps{
  label?: string;
  ref?: any
}
const EmptyDataButton : React.FC<EmptyDataButtonProps> = ({label}) => {

    const [isLargeModalOpen, setLargeModalIsOpen] = useState(false);

    const toggleLargeModal = () => {
      setLargeModalIsOpen(!isLargeModalOpen);
    }

    const modalData = {
      "headerTitle": "Data not provided by club",
      "actionTag": " ",
      "items": [
          {
              "subTitle": " ",
              "description": "Leeds United are situated in a country who’s laws to not require them to make public the data we’d need to fully calculate this sum.",

          },
      ],
    }
  return (
      <>
          <LargeModal toggleLargeModal={toggleLargeModal}
              isOpen={isLargeModalOpen}
              data={modalData} />
          <Button onClick={toggleLargeModal}>
              <LabelText className='empty-data-text not-available-data'>{label}</LabelText>
              <HelpOutlineIcon className="clickable" style={{width:'16px',height:'16px'}}/>
          </Button>
      </>
  )
}
export default EmptyDataButton